import type { LabelHTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: generic label component — htmlFor is passed via props
    <label
      className={cn(
        'font-semibold text-base text-foreground leading-body peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
